import React from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Result } from 'antd';
import { hasPermission, pageModule } from './usePermissions';

export default function RequirePermission({ permission }) {
  const user = useSelector(state => state.user);
  const location = useLocation();
  if (location.pathname === '/avoir') permission = pageModule(location.pathname, location.search);
  const allowed = typeof permission === 'function' ? permission(user) : hasPermission(user, permission);
  return allowed ? <Outlet /> : <Result status="403" title="Accès refusé"
    subTitle="Vous n’avez pas la permission d’accéder à cette page."
    extra={<Link to="/">Retour à l’accueil</Link>} />;
}
